import React from "react";

const WhereWork = ({ where_work_video }) => {
  return (
    <div className="container-fluid pt-7" id="where-we-works">
      <div className="ms-47 me-47">
        <div className="row pb-7">
          <div className="col-lg-2">
            <h1 className="fs-28 text-capitalize mb-4">Where we work</h1>
          </div>
          <div
            className="col-lg-10 where-we-work-video"
            dangerouslySetInnerHTML={{ __html: where_work_video?.embedded }}
          />
        </div>
        <hr />
      </div>
    </div>
  );
};

export default WhereWork;
